
import TickCircle from "../../../assets/filled/TickCircle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TickCircleIcon({ className, dataTestid = "TickCircleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <TickCircle data-testid={dataTestid} className={classes} {...rest} />
  );
}
